/* 
 * 接口统一集成模块
 */
import * as login from './moudules/login'
import * as user from './moudules/user'
import * as dept from './moudules/dept'
import * as role from './moudules/role'
import * as menu from './moudules/menu'
import * as dict from './moudules/dict'
import * as log from './moudules/log'
import * as banner from './moudules/banner'
import * as category from './moudules/category'
import * as theme from './moudules/theme'
import * as shop from './moudules/shop'
import * as goods from './moudules/goods'
import * as orders from './moudules/order'
import * as logistics from './moudules/logistics'
import * as client from './moudules/client'
import * as address from './moudules/address'

// 默认全部导出
export default {
    login,
    user,
    dept,
    role,
    menu,
    dict,
    log,
    banner,
    category,
    theme,
    shop,
    goods,
    orders,
    logistics,
    client,
    address
}


// WEBPACK FOOTER //
// ./src/http/api.js